"use client";

import CreateOrEditGift from "@/components/core/gift/create-update-gift";
import { useSearchParams } from "next/navigation";

interface OrderProduct {
  order_product_id: number;
  product_id: number;
  name: string;
  model: string;
  quantity: number;
  price: string;
  image: string;
}

interface OrderData {
  order_id: number;
  customer_name: string;
  products: OrderProduct[];
}

interface CreateGiftContentProps {
  lang: string;
  preloadedOrderData?: OrderData;
  orderUuid?: string;
  orderProductId?: number;
}

const CreateGiftContent = ({
  lang,
  preloadedOrderData,
  orderUuid,
  orderProductId,
}: CreateGiftContentProps) => {
  const searchParams = useSearchParams();

  if (preloadedOrderData && orderUuid && orderProductId) {
    const lockedProduct =
      preloadedOrderData.products.find((p) => p.order_product_id === orderProductId) ??
      preloadedOrderData.products[0] ??
      null;

    return (
      <CreateOrEditGift
        lang={lang}
        gift={""}
        presetProduct={String(lockedProduct?.product_id ?? "")}
        presetQuantity={lockedProduct?.quantity ?? null}
        presetproperties={null}
        orderUuid={orderUuid}
        lockedOrderProductId={lockedProduct?.order_product_id ?? null}
        isProductLocked={!!lockedProduct}
      />
    );
  }

  const presetProduct = searchParams.get("product");
  const presetproperties = searchParams.get("option");
  const presetQuantity = Number(searchParams.get("quantity"));

  return (
    <CreateOrEditGift
      lang={lang}
      gift={""}
      presetProduct={presetProduct}
      presetQuantity={presetQuantity}
      presetproperties={presetproperties}
    />
  );
};

export default CreateGiftContent;
